import React, { FC } from 'react'
import cn from 'classnames'
import { DivProps } from '@commonTypes'
import css from './colorMarker.module.scss'

type ColorMarkerProps = DivProps & {
  color: string
}

const ColorMarker: FC<React.PropsWithChildren<ColorMarkerProps>> = ({
  color,
  className,
  style,
  ...props
}) => {
  return (
    <div
      className={cn(css.marker, className)}
      style={{ backgroundColor: color, ...style }}
      {...props}
    />
  )
}

export default ColorMarker
